import type { StyleLayer } from './utils/types'

export const layers_parkingTilda_off_kind_area: StyleLayer[] = [
  {
    id: 'off_kind_bg',
    type: 'fill',
    paint: {
      'fill-color': [
        'case',
        ['match', ['get', 'category'], ['multi-storey', 'rooftop'], true, false],
        'rgb(233, 91, 84)',
        ['match', ['get', 'category'], ['underground'], true, false],
        'rgb(142, 192, 169)',
        [
          'match',
          ['get', 'category'],
          ['garage', 'garages', 'garage_boxes', 'sheds', 'carport', 'carports'],
          true,
          false,
        ],
        'rgb(251, 206, 74)',
        'rgb(48, 159, 219)',
      ],
      'fill-opacity': 0.33,
    },
  },
  {
    id: 'off_kind_outline',
    type: 'line',
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'category'], ['multi-storey', 'rooftop'], true, false],
        'rgb(233, 91, 84)',
        ['match', ['get', 'category'], ['underground'], true, false],
        'rgb(142, 192, 169)',
        [
          'match',
          ['get', 'category'],
          ['garage', 'garages', 'garage_boxes', 'sheds', 'carport', 'carports'],
          true,
          false,
        ],
        'rgb(251, 206, 74)',
        'rgb(48, 159, 219)',
      ],
      'line-dasharray': [
        'case',
        ['==', ['get', 'parking'], 'underground'],
        ['literal', [3, 2]],
        ['literal', []],
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.67, 20, 5.33],
    },
  },
]
